module.exports = __webpack_public_path__ + "img/lotto-5-45.430e7a23.png";